import { FieldChangeEventBus } from '@/shared/services/field-change-event-bus';

export const WOFieldChangeEventBusInstance = new FieldChangeEventBus();
